import React, { FC, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectConversationId, ProjectId } from 'api/models';
import {
  ProjectConversation,
  ProjectConversationFormPayload,
  UpdateConversationFormItems,
} from 'api/project-conversations';
import { useUpdateProjectConversationsMutation } from 'queries/project-wide-conversation';
import { ConversationForm } from '../../conv-form';

interface UpdateConversationFormProps {
  onSuccess: () => void;
  activeConversation: ProjectConversation;
  projectId: ProjectId;
}

interface UpdateProjectConversationFormPayload
  extends Partial<ProjectConversationFormPayload> {
  conversationId?: number;
}

export const UpdateConversationForm: FC<UpdateConversationFormProps> = (
  props,
) => {
  const { onSuccess, activeConversation, projectId } = props;
  const [formInitialValues, setFormInitialValues] = useState<
    UpdateProjectConversationFormPayload | undefined
  >({
    conversationId: activeConversation.conversationId,
    [UpdateConversationFormItems.ConversationName]:
      activeConversation.conversationName,
    [UpdateConversationFormItems.ConversationDescription]:
      activeConversation.conversationDescription,
  });

  const {
    mutate: updateConversationMuatate,
    isLoading: isUpdateConversationCreationLoading,
  } = useUpdateProjectConversationsMutation(
    projectId,
    ProjectConversationId(activeConversation.conversationId),
  );

  const onSubmit = (form) => {
    const formData = form.getFieldsValue(true);

    updateConversationMuatate(
      {
        conversationName:
          formData[UpdateConversationFormItems.ConversationName],
        conversationDescription:
          formData[UpdateConversationFormItems.ConversationDescription],
      },
      {
        onSuccess: () => {
          if (onSuccess) {
            onSuccess();
          }
        },
      },
    );
  };

  useEffect(() => {
    if (
      activeConversation.conversationId !== formInitialValues?.conversationId
    ) {
      // queueMacrotask(() => {
      setFormInitialValues({
        conversationId: activeConversation.conversationId,
        [UpdateConversationFormItems.ConversationName]:
          activeConversation.conversationName,
        [UpdateConversationFormItems.ConversationDescription]:
          activeConversation.conversationDescription,
      });
      // });
    }
  }, [activeConversation, formInitialValues]);

  return formInitialValues ? (
    <ConversationForm
      onSubmit={onSubmit}
      hidePrivateCheckbox
      submitText={
        <FormattedMessage id="projects.conversations.form.channel.update" />
      }
      initialValues={formInitialValues}
      name="updateConversationForm"
      loading={isUpdateConversationCreationLoading}
    />
  ) : null;
};
